// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function assertNever(_x: never): never {
    throw new Error('assertNever failed');
}
